/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { MailTag } from '../model/mail-tag';

export class ValidationEngine {
  /**
   * Validate mail address
   * @param mail
   * @param required
   */
  public static validateMail(mail: string, required?: boolean): boolean {
    if (!required && (!mail || mail.length === 0)) {
      return true;
    } else if (required && !mail) {
      return false;
    } else {
      const regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const mails = mail.split(/[\s|;|,]/);
      for (const m of mails) {
        if (m.length === 0 || !regex.test(m)) {
          return false;
        }
      }
      return true;
    }
  }

  /**
   * Validate mail address
   * @param mail
   * @param required
   */
  public static validateMailTag(tags: MailTag[], required?: boolean): boolean {
    if (!tags || tags.length === 0) {
      return !required;
    } else {
      for (const tag of tags) {
        const check = ValidationEngine.validateMail(tag.value);
        if (!check) {
          return false;
        }
      }
    }
    return true;
  }

  /**
   * Check keydown value for time or number input
   * @param event
   */
  public static checkKeyboardEventIsNumber(event: any) {
    const specialChar = [8, 9, 27, 46, 13, 188, 190];
    if (
      specialChar.find((special) => {
        return event.keyCode === special;
      }) !== undefined ||
      // Allow: Ctrl/cmd+A
      (event.keyCode === 65 &&
        (event.ctrlKey === true || event.metaKey === true)) ||
      // Allow: Ctrl/cmd+C
      (event.keyCode === 67 &&
        (event.ctrlKey === true || event.metaKey === true)) ||
      // Allow: Ctrl/cmd+X
      (event.keyCode === 88 &&
        (event.ctrlKey === true || event.metaKey === true)) ||
      // Allow: home, end, left, right
      (event.keyCode >= 35 && event.keyCode <= 39)
    ) {
      // let it happen, don't do anything
      return true;
    }
    if (
      event.keyCode === 110 &&
      event.srcElement.value &&
      event.srcElement.value.indexOf('.') === -1
    ) {
      return true;
    }
    // Ensure that it is a number and stop the keypress
    if (isNaN(parseInt(event.key, 10))) {
      event.preventDefault();
      return false;
    }
    return true;
  }
}
